import { render, staticRenderFns } from "./yckList.vue?vue&type=template&id=5f59066e&scoped=true&"
import script from "./yckList.vue?vue&type=script&lang=js&"
export * from "./yckList.vue?vue&type=script&lang=js&"
import style0 from "./yckList.vue?vue&type=style&index=0&id=5f59066e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59066e",
  null
  
)

export default component.exports